import { motion } from 'framer-motion';

// The only animated primitive besides the CSS highlighter mark.
// Reduced motion is handled by <MotionConfig reducedMotion="user"> in App.js (transforms are dropped).
export default function Reveal({ children, className = '' }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 8 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '0px 0px -10% 0px' }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  );
}
